"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveMuiTheme = exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _styles = require("@material-ui/core/styles");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    formControlLabel: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formControlLabel', 'backgroundColor'], 'transparent'),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formControlLabel', 'color'], "".concat(_colors["default"].gray)),
      height: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formControlLabel', 'height'], 36),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formControlLabel', 'width'], "100%"),
      margin: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formControlLabel', 'margin'], "0px 0px 0px 0px")
    },
    topDivider: {
      borderTop: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'topDivider', 'borderTop'], "solid 1px ".concat(_colors["default"].dividerBase))
    },
    divider: {
      borderBottom: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'divider', 'borderBottom'], "solid 1px ".concat(_colors["default"].dividerBase))
    },
    root: {
      fontFamily: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'fontFamiliy'], "Roboto, Helvetica, sans-serif"),
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'backgroundColor'], "".concat(_colors["default"].white)),
      height: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'height'], 38),
      margin: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'margin'], "0px 0px 10px 0px"),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'width'], '100%'),
      transition: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'transition'], "all 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"),
      willChange: 'left, width',
      '&:hover:not($selected)': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'hover', 'backgroundColor'], "transparent"),
        transition: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'hoverTransition', 'transition'], 'background-color 0.75s ease')
      },
      '&$selected': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'selectedColor', 'backgroundColor'], "transparent")
      }
    },
    textColorPrimary: {
      '&$selected': {
        color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'textColorPrimary', 'color'], "".concat(_colors["default"].white))
      }
    },
    selected: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'selected'], {})
  };
};

exports.retrieveStyle = retrieveStyle;

var retrieveMuiTheme = function retrieveMuiTheme(theme) {
  return (0, _styles.createMuiTheme)({
    overrides: {
      MuiTypography: {
        body1: {
          fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily'], 'Roboto'),
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontSize'], "14px"),
          color: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'color'], "currentColor"),
          width: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'width'])
        }
      },
      MuiRadio: {
        colorSecondary: {
          color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'root', 'color'], "".concat(_colors["default"].gray)),
          '&$checked': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'selected', 'color'], "".concat(_colors["default"].inputPrimary))
          },
          '&$disabled': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'disabled', 'color'], "".concat(_colors["default"].disabledGray))
          }
        }
      },
      MuiFormLabel: {
        root: {
          color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formLabel', 'color']),
          '&$error': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formLabel', 'errorColor'], _colors["default"].gray)
          },
          '&$focused': {
            color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formLabel', 'focusedColor'], _colors["default"].primary),
            '&$error': {
              color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'formLabel', 'focusedErrorColor'], _colors["default"].error)
            }
          },
          fontFamily: (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'fontFamily']),
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium'], 14))
        }
      },
      MuiFormHelperText: {
        root: {
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'helperText', 'fontSize'], 12),
          color: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'helperText', 'color'], _colors["default"].error)
        }
      },
      MuiSvgIcon: {
        root: {
          fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTRadioGroup', 'radioButton', 'fontSize'], 24)
        }
      }
    }
  });
};

exports.retrieveMuiTheme = retrieveMuiTheme;